export default __webpack_public_path__ + "static/media/editorZoomOut.c42b529b.svg";